/* eslint-disable max-len, no-trailing-spaces, eol-last, indent, comma-dangle, comma-spacing, prefer-const, spaced-comment, key-spacing, no-multi-spaces, semi, object-property-newline, quotes, react/display-name, id-length, operator-linebreak, react/prop-types, no-shadow, no-undef, max-lines-per-function, space-infix-ops, no-unused-vars, init-declarations */
import { serviceName } from '../resources/serviceConstants';
import { DRI_LIST, PERFORMANCE_PERIOD_MASTER, PERFORMANCE_KPI_DETAILS, DECLARE_SOURCE_REMARK} from '../resources/endPoint';

export const getDriDetails = (emailId) => {
  // API call to fetch awards details
  const data = {
    emailId: emailId,
  };

  return {
    url: DRI_LIST,
    method: 'post',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.PERFORMANCE_MS,
  };
};

export const getPerformancePeriodDetails = () => {
  // API call to fetch performance master details
  return {
    url: PERFORMANCE_PERIOD_MASTER,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.PERFORMANCE_MS,
  };
};

export const addPerformancePeriod = (data) => {
  // API call to add performance cycle data

  return {
    url: PERFORMANCE_PERIOD_MASTER,
    method: 'post',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.PERFORMANCE_MS,
  };
};

export const updatePerformancePeriod = (data) => {
  return {
    url: PERFORMANCE_PERIOD_MASTER,
    method: 'put',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.PERFORMANCE_MS,
  };
};

export const getPerformanceKpiDetails = (data) => {
  return {
    url: PERFORMANCE_KPI_DETAILS,
    method: 'post',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.PERFORMANCE_MS,
  };
};

export const getKpiSourceAndRemarksDetails = () => {
  // API call to fetch kpi source and remark details
  return {
    url: DECLARE_SOURCE_REMARK,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.PERFORMANCE_MS,
  };
};

export const updateKpiSourceAndRemarksDetails = (data) => {
  // API call to update kpi source and remark details
  return {
    url: DECLARE_SOURCE_REMARK,
    method: 'put',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.PERFORMANCE_MS,
  };
};